import app from './app.json';
import common from './common.json';
import page from './page.json';
const daDK = {
    app,
    common,
    page
};
export default daDK;
